import "./styles/home.scss";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Testimonials from "./pages/Testimonials";
import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
  Button,
  Stack,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import event from "./images/event.webp";
import telegram from "./images/support_group.webp";
import online from "./images/ZoomCall.webp";
import retreat from "./images/retreat.webp";
import HowTo from "./pages/HowTo";
import paulCropped from "./images/paul_cropped.webp";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import thumb from './images/thumbnail.webp'

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  "@media(max-width: 700px)": {
    width: "90vw",
    maxHeight: "80vh",
  },
};

export default function Home() {
  const [showNonEssential, setShowNonEssential] = useState(false);
  const navigate = useNavigate();
  // COOKIES
  const [open, setOpen] = useState(true);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    let cookies = localStorage.getItem("pmw_cookies");
    if (cookies) {
      handleClose();
    }
  }, []);

  const handleCookies = () => {
    let pmw_cooks = true;

    localStorage.setItem("pmw_cookies", pmw_cooks);
    handleClose();
  };

  const handleCustomise = () => {
    setShowNonEssential(true);
  };

  function gtag() {
    window.dataLayer.push(arguments);
  }

  const handleConsent = (cookie, value) => {
    if (value == false) {
      gtag("consent", "update", {
        [cookie]: "denied",
      });
    } else {
      gtag("consent", "update", {
        [cookie]: "granted",
      });
    }
  };

  const handleDecline = async () => {
    await gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });

    handleClose();
  };

  const scrollTo = () => {
    document.getElementById("how").scrollIntoView();
  };

  return (
    <main className="home__main">
      <section className="hero">
        <h1>The Elite Business Mastermind</h1>
        <p>Scale Faster, Achieve More, and Accelerate Your Business Growth</p>

        <div class="video-container">
          <ReactPlayer
            url="https://vimeo.com/1082145923?share=copy"
            width="100%"
            height="100%"
            className="iframe"
            light={thumb}
            controls
          />
        </div>

        <button className="enrol_button" onClick={() => navigate("/register")}>
          Apply Now
        </button>
      </section>
      <section className="extras">
        <h2>More About The Elite Business Mastermind</h2>
        <hr />
        <section className="extra__boxes">
          <aside className="text__side">
            <h4>Live Mastermind Events</h4>
            <p>
              Attend four in-person mastermind sessions designed to help you
              unlock growth, overcome challenges, and scale your business. Each
              session delivers actionable strategies and expert guidance to
              drive immediate results and measurable progress. Event recordings
              are included, so you can revisit insights and stay on track.
            </p>
          </aside>
          <img src={event} alt="In Person Event" />
        </section>
        <section className="extra__boxes">
          <aside className="text__side">
            <h4>Monthly Online Coaching Sessions</h4>
            <p>
              Stay focused and keep moving forward with monthly coaching
              sessions. Get expert guidance, accountability, and support to
              build on what you’ve learned in the live events. Use these
              sessions to ask questions, overcome challenges, and get practical
              advice for your business.
            </p>
          </aside>
          <img src={online} alt="Online Sessions" />
        </section>
        <section className="extra__boxes">
          <aside className="text__side">
            <h4>Private Support Group</h4>
            <p>
              Get 24/7 access to a supportive community of peers and mentors.
              Use this space to solve problems, get feedback, and connect with
              like-minded entrepreneurs. It’s the perfect place to overcome
              challenges, share ideas, and explore growth opportunities with
              expert guidance.
            </p>
          </aside>
          <img src={telegram} alt="Private telegram group" />
        </section>
        <section className="extra__boxes pulsing">
          <aside className="text__side" onClick={scrollTo}>
            <h4>Annual Retreat</h4>
            <p>
              You’re invited to an exclusive retreat that combines business
              development with relaxation. Strengthen connections with fellow
              entrepreneurs, recharge, and return with fresh strategies to apply
              directly to your business for ongoing success.
            </p>
          </aside>
          <img src={retreat} alt="PMW Retreat" />
        </section>

        <button className="enrol_button" onClick={() => navigate("/register")}>
          Apply Now
        </button>
      </section>

      {/* WHO IS IT FOR */}
      <section className="includedSection">
        <h2>The Elite Mastermind Is For You If</h2>
        <hr></hr>
        <section className="included">
          <section className="column">
            <section className=" left wiif test">
              <aside className="side">
                <TaskAltIcon className="online--icon" />
                <h6>Lacking a Clear Growth Plan:</h6>
              </aside>
              <p>
                Not sure what steps to take to scale your business? We’ll help
                you create a simple, clear plan to reach your goals and move
                forward with confidence.
              </p>
            </section>

            <section className=" left wiif">
              <aside className="side">
                <TaskAltIcon className="online--icon" />
                <h6>Struggling to Scale:</h6>
              </aside>
              <p>
                Has your business hit a plateau? We’ll help you identify
                bottlenecks, unlock new opportunities, and implement strategies
                to reignite growth and achieve the next level of success.
              </p>
            </section>
          </section>

          <section className="column">
            <section className=" right wiif">
              <aside className="side">
                <TaskAltIcon className="online--icon" />
                <h6>Stuck in Daily Operations:</h6>
              </aside>
              <p>
                Overwhelmed by daily tasks? We’ll show you how to streamline
                operations, delegate tasks, and focus on high-impact activities
                that accelerate growth.
              </p>
            </section>

            <section className=" right wiif">
              <aside className="side">
                <TaskAltIcon className="online--icon" />
                <h6>Want More Clients and Sales:</h6>
              </aside>
              <p>
                Finding it hard to attract the right clients or close deals?
                You’ll learn proven marketing and sales strategies to generate
                quality leads, close more deals, and build a steady pipeline of
                high-value clients.
              </p>
            </section>
          </section>
        </section>
      </section>

      {/* <TimeLine /> */}
      <HowTo />

      <Testimonials />
      <section className="bio">
        <img src={paulCropped} alt="Paul McFadden" />
        <article>
          <h2>Paul McFadden</h2>
          <p>
            Paul McFadden is a renowned entrepreneur, award-winning educator in
            wealth building, and a leading authority on business growth and
            wealth creation. Starting his entrepreneurial journey at just 19,
            Paul quickly built a multi-million-pound property portfolio,
            achieving financial freedom and millionaire status by the age of 26.
            Leveraging his early success, he expanded into multiple business
            ventures, collectively generating an annual eight-figure turnover.
          </p>
          <p>
            With a proven track record of scaling businesses, Paul has become a
            trusted mentor and coach to both aspiring entrepreneurs and seasoned
            business owners. His insights and strategies have empowered
            thousands to grow their businesses and attain financial
            independence. Recognised globally for his expertise, Paul is a
            highly sought-after speaker at prestigious business and property
            events.
          </p>
          <p>
            His contributions to wealth education have earned him an honorary
            membership in Robert Kiyosaki’s Wealth Master Panel. In 2022, Paul
            further cemented his status as a global business leader by joining
            the prestigious ClickFunnels Eight-Figure Club, having generated
            over £10,000,000 in revenue from a single offering.
          </p>
        </article>
      </section>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            We Use Cookies
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            We use cookies to ensure the best experience on our website. These
            help us improve our site performance, personalise content, and
            deliver targeted ads.
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            By clicking "Accept All Cookies," you agree to the use of all
            cookies. You can manage your preferences by selecting "Customise
            Settings" or view our full Cookie Policy for more information.
          </Typography>
          {showNonEssential ? (
            <Stack>
              <FormGroup>
                <FormControlLabel
                  disabled
                  control={<Switch defaultChecked />}
                  label="Essential Cookies"
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Performance Cookies"
                  onChange={(e) =>
                    handleConsent("performance", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Functionality Cookies"
                  onChange={(e) =>
                    handleConsent("ad_personalization", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Analytics Cookies"
                  onChange={(e) =>
                    handleConsent("analytics_storage", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Adverstising Cookies"
                  onChange={(e) =>
                    handleConsent("ad_storage", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Social Media Cookies"
                  onChange={(e) =>
                    handleConsent("ad_user_data", e.target.checked)
                  }
                />
              </FormGroup>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{ marginTop: "5%" }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleCookies}
                >
                  Accept Custom
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleCookies}
                >
                  Accept All
                </Button>
              </Stack>
            </Stack>
          ) : (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              sx={{ marginTop: "5%" }}
            >
              <Button
                variant="outlined"
                color="success"
                onClick={handleCookies}
              >
                Accept Cookies
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCustomise}
              >
                Customise Settings
              </Button>
              <Button
                variant="outlined"
                color="success"
                onClick={handleDecline}
              >
                Decline Non-Essential
              </Button>
            </Stack>
          )}
        </Box>
      </Modal>
    </main>
  );
}
